<template>
    <section
        class="md-search-more md-search-more-center clearfix broker"
        :class="[cls || '']"
        @touchend="onTouchend"
    >
        <div class="search-by-section">
            <!-- autocomplete start -->
            <div
                class="keyword-container"
                v-show="showLocation"
                @click="expand"
            >
                <div
                    class="search-category show-all"
                    :class="{
                        'keyword-only': keywordOnly,
                        compose: composeLayout
                    }"
                >
                    <SearchTag
                        @update="updateTag"
                        :collapse="collapse"
                        :filter="['mapPath', 'mapSearch', 'key', 'mapRadius']"
                        v-if="!keywordOnly"
                    />
                    <div
                        v-show="isMobileSize || !hasTag || !collapse"
                        :class="{ keyword: true, 'first-line': !hasTag }"
                    >
                        <!--  @input="showSuggestion" v-model="keyword"-->
                        <input
                            type="search"
                            class="search-input sug"
                            ref="input"
                            @input="handleInput"
                            @click.stop="inputClick"
                            @keypress.enter="handleEnterAndTrack()"
                            v-model="keyword"
                            :placeholder="keywordPlaceholders"
                            autocomplete="off"
                            :aria-label="keywordPlaceholders || 'Search keyword'"
                        />
                        <div
                            class="keyword-submit"
                            role="button"
                            tabindex="0"
                            :aria-label="keywordPlaceholders || 'Search keyword'"
                            @click="handleEnter()"
                        >
                            <i class="iconfont icon-search" aria-hidden="true"></i>
                        </div>
                        <template v-if="keywordOnly">
                            <div
                                class="btn-remove iconfont icon-close"
                                @click="keyword = ''"
                                v-show="keyword"
                            ></div>
                            <div class="btn-close" @click="close">
                                {{ $t('md-search-bar.close') }}
                            </div>
                        </template>
                        <!--  searched for  suggestion list drop down   start -->
                        <div
                            class="list-panel panel-style"
                            v-if="
                                (doShowSuggestion &&
                                    keyWordSuggestion.length) ||
                                    keywordOnly
                            "
                        >
                            <ul class="reco-search" @click.stop>
                                <template v-if="recentlySearch.length > 0">
                                    <li key="recentlySearch" class="type-title">
                                        {{ $t('md-search-bar.recentlySearch') }}
                                    </li>
                                    <li
                                        v-for="(item, index) in recentlySearch"
                                        :key="
                                            item.keywordType +
                                                '-recent-' +
                                                index
                                        "
                                        :type="item.keywordType"
                                        @click="
                                            clickSuggestion(
                                                item.keywordType,
                                                item.keyword
                                            )
                                        "
                                    >
                                        {{ item.keyword }}
                                    </li>
                                </template>
                                <template
                                    v-for="(item, index) in keyWordSuggestion"
                                >
                                    <!-- !keyname  for customizedCity Case  -->
                                    <li
                                        v-if="!item.value"
                                        :key="'type-' + index"
                                        class="type-title"
                                    >
                                        {{ item.label }}
                                    </li>
                                    <li
                                        v-else
                                        :key="item.type + '-' + index"
                                        :type="item.type"
                                        @click="
                                            clickSuggestion(
                                                item.type,
                                                item.value
                                            )
                                        "
                                    >
                                        {{ item.label }}
                                    </li>
                                </template>
                            </ul>
                        </div>
                        <!--  searched for  suggestion list drop down   end -->
                    </div>
                    <div
                        class="keyword-submit"
                        role="button"
                        tabindex="0"
                        :aria-label="'Search'"
                        @click="handleEnter()"
                    >
                        <i class="iconfont icon-search"></i>
                        <div>
                            <label>{{ $t('md-search-bar.search0') }}</label>
                        </div>
                    </div>
                </div>
                <template v-if="!isMobileSize">
                    <!-- save search start -->
                    <label
                        :class="['save-search', 'hide-icon']"
                        v-if="
                            !forCMS &&
                                !hideSearchBtn &&
                                !locationOnly &&
                                searchBarOnly
                        "
                        @click="saveSearch"
                    >{{ $t('md-search-bar.search') }}</label>
                    <label
                        :class="['save-search', saveAble ? '' : ' disabled']"
                        v-if="
                            !forCMS &&
                                !hideSearchBtn &&
                                !locationOnly &&
                                !searchBarOnly &&
                                listingType !== 'sold-listing' &&
                                !widget
                        "
                        @click="saveSearch"
                    >
                        <span class="iconfont icon-heart-fill"></span>{{ $t('md-search-bar.saveSearch') }}</label>

                    <im-popper
                        v-if="
                            !forCMS &&
                                !locationOnly &&
                                (hideSearchBtn || listingType == 'sold-listing') &&
                                !widget
                        "
                        :disabled="snapshotAbled"
                        :visibleArrow="true"
                        :hover="true"
                        :popperHover="true"
                        placement="top-start"
                        :offset="[0, 8]"
                    >
                        <template #reference>
                            <label
                                :class="[
                                    'save-search',
                                    'save-snapshot',
                                    snapshotAbled ? '' : ' disabled'
                                ]"
                                @click="clickSaveSnapshot"
                            >{{ $t('md-search-bar.saveSnapshot') }}</label>
                        </template>
                        <template #default>
                            <div class="tooltip dark">
                                {{ cmpSnapshotHoverTip }}
                            </div>
                        </template>
                    </im-popper>
                    <!-- save search end -->
                </template>
            </div>
            <!-- autocomplete end -->
            <!-- mobile  end display search bar  style  -->
            <SearchTag
                class="mobile"
                v-if="!keywordOnly && isMobileSize"
                :exclude="true"
                :conditionSort="conditionSort"
                :filter="ignoreTags"
            />
            <!-- mobile  end display search bar  style  -->
            <!-- PC  end display   Apart from  location suggestions autocomplete style of  -->
            <div
                v-if="!keywordOnly && !locationOnly"
                class="search-more search-detail mg-scrollbar"
                :class="{ onlymap: !composeLayout, compose: composeLayout }"
                ref="searchMoreContainer"
            >
                <template v-if="!isMobileSize">
                    <div class="search-detail-wrap">
                        <template v-for="item in propertyConfigs">
                            <div
                                :key="item.name"
                                v-if="item.inputType == 'suggestion'"
                                class="search-detail-item"
                                data-type="SuggestionPC"
                            >
                                <Suggestion
                                    :data="item"
                                    :label="item.label"
                                    :kee="item.name"
                                    :key="item.name"
                                    :inMore="false"
                                    :siteId="siteId"
                                    theme="broker"
                                    :value="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) ||
                                            []
                                    "
                                    @change="updateCondition"
                                />
                            </div>
                            <div
                                :key="item.name"
                                v-if="
                                    item.inputType == 'singleSelect' ||
                                        item.inputType == 'multiSelect'
                                "
                                data-type="SelectVirtual"
                                class="search-detail-item"
                            >
                                <SelectVirtual
                                    :multiple="item.inputType == 'multiSelect'"
                                    :inputType="item.inputType"
                                    :options="item.options"
                                    :label="item.label"
                                    :kee="item.name"
                                    :hasFilter="0"
                                    type="dropdown"
                                    theme="broker"
                                    :value="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) || ['']
                                    "
                                    @change="updateCondition"
                                    @toogledropdown="toogledropdownOuter"
                                />
                            </div>
                            <div
                                :key="item.name"
                                v-if="
                                    item.inputType == 'inputBox' ||
                                        item.inputType == 'text' ||
                                        item.inputType == 'keyWord'
                                "
                                data-type="OutsideRange"
                                class="search-detail-item"
                            >
                                <OutsideRange
                                    cls="selectdown click-show-list"
                                    :data="item"
                                    :label="item.label"
                                    :kee="item.name"
                                    :inMore="false"
                                    :value="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) ||
                                            ''
                                    "
                                    theme="broker"
                                    @change="updateCondition"
                                />
                            </div>
                            <div
                                :key="item.name"
                                v-if="item.inputType == 'checkBox'"
                                class="search-detail-item"
                                data-type="OutsideCheckbox"
                            >
                                <OutsideCheckbox
                                    cls="selectdown click-show-list"
                                    :data="item"
                                    :label="item.label"
                                    :kee="item.name"
                                    :inMore="false"
                                    theme="broker"
                                    :checked="
                                        (conditions[item.name] &&
                                            conditions[item.name].value) ||
                                            false
                                    "
                                    @change="updateSelected"
                                />
                            </div>
                        </template>
                        <!-- More start -->
                        <div
                            :class="
                                'search-detail-item more-btn' +
                                    (showMore ? ' open' : '')
                            "
                            @click="clickMore"
                            v-show="showMoreBtn && !widget"
                        >
                            <div class="box-div">
                                <!-- <span class="logo iconfont icon-list"></span> -->
                                <label class="text">{{
                                    $t('md-search-bar.filters')
                                }}</label>
                                <label class="more-len" v-if="moreLen">{{
                                    moreLen
                                }}</label>
                                <!-- <span class="iconfont icon-arrow-down"></span> -->
                            </div>
                        </div>
                        <!-- More end -->
                    </div>
                </template>
                <!-- more -->

                <!--  click  more content of popup layer  start -->
                <!-- @click="clickMoreBox" -->
                <template v-if="!keywordOnly && !locationOnly">
                    <div
                        ref="more"
                        :class="
                            'mg-container more-list' +
                                (showMore ? ' show-more-list' : '')
                        "
                        v-outsideclick="clickMoreOut"
                        :style="{
                            height: !isMobileSize ? moreHeight + 'px' : 'auto'
                        }"
                    >
                        <label class="checkbox-values"></label>
                        <div class="more-list-scroll mg-scrollbar">
                            <div class="more-reset" @click="reset">
                                <span class="iconfont icon-reset"></span>{{ $t('md-search-bar.reset') }}
                            </div>
                            <div
                                class="section-box search_tag"
                                v-if="!keywordOnly && !isMobileSize"
                            >
                                <SearchTag
                                    :exclude="true"
                                    :filter="tagFilter"
                                    :hideRemoveAll="true"
                                    :collapse="false"
                                    :conditionSort="conditionSort"
                                    :inMore="true"
                                />
                            </div>
                            <div
                                v-for="(item, sectionIndex) in searchList"
                                :key="item.id"
                                :class="
                                    'section-box' +
                                        (item.column == 2 ? ' section-second' : '')
                                "
                            >
                                <h2
                                    :class="{
                                        'show-list':
                                            activeSectionIndex === sectionIndex
                                    }"
                                    @click="toggleActiveSection(sectionIndex)"
                                >
                                    <label class="text">{{
                                        item.nameText || item.name
                                    }}</label>
                                    <span
                                        class="iconfont icon-arrow-down"
                                    ></span>
                                </h2>
                                <div class="section" v-for="(childItem,cIndex) in item.conditions" :key="cIndex">
                                    <Checkbox
                                        v-if="
                                            childItem.inputType ==
                                                'checkBox'
                                        "
                                        :key="childItem.name"
                                        :kee="childItem.name"
                                        :label="childItem.label"
                                        :inMore="true"
                                        :checked="
                                            (conditions[childItem.name] &&
                                                conditions[childItem.name]
                                                    .value) ||
                                                false
                                        "
                                        @change="updateSelected"
                                    />
                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType ==
                                                'inputBox'
                                        "
                                        :key="childItem.name"
                                    >
                                        <Range
                                            cls="range-input-parent"
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            :theme="'broker'"
                                            :inMore="true"
                                            :value="
                                                (conditions[
                                                    childItem.name
                                                ] &&
                                                    conditions[
                                                        childItem.name
                                                    ].value) ||
                                                    ''
                                            "
                                            @change="updateCondition"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType ==
                                                'singleSelect' ||
                                                childItem.inputType ==
                                                'multiSelect'
                                        "
                                        :key="childItem.name"
                                    >
                                        <SelectVirtual
                                            :multiple="
                                                childItem.inputType ==
                                                    'multiSelect'
                                            "
                                            :inputType="childItem.inputType"
                                            :options="childItem.options"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            :theme="'broker'"
                                            type="input"
                                            :value="
                                                (conditions[
                                                    childItem.name
                                                ] &&
                                                    conditions[
                                                        childItem.name
                                                    ].value) || ['']
                                            "
                                            @change="updateCondition"
                                            @toogledropdown="toogledropdown"
                                        />
                                    </div>

                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType === 'text'
                                        "
                                        :key="childItem.name"
                                    >
                                        <SInput
                                            cls="range-input-parent"
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            :inMore="true"
                                            theme="broker"
                                            :value="
                                                (conditions[
                                                    childItem.name
                                                ] &&
                                                    conditions[
                                                        childItem.name
                                                    ].value) ||
                                                    ''
                                            "
                                            @change="updateCondition"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType ===
                                                'keyWord'
                                        "
                                        :key="childItem.name"
                                    >
                                        <Keyword
                                            cls="range-input-parent"
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            theme="broker"
                                            :inMore="true"
                                            @change="updateCondition"
                                        />
                                    </div>
                                    <div
                                        class="inputtext-area"
                                        v-if="
                                            childItem.inputType ===
                                                'suggestion'
                                        "
                                        :key="childItem.name"
                                    >
                                        <!--  cls="range-input-parent" -->
                                        <Suggestion
                                            :data="childItem"
                                            :label="childItem.label"
                                            :kee="childItem.name"
                                            :key="childItem.name"
                                            :inMore="true"
                                            :siteId="siteId"
                                            theme="broker"
                                            :value="
                                                (conditions[
                                                    childItem.name
                                                ] &&
                                                    conditions[
                                                        childItem.name
                                                    ].value) ||
                                                    []
                                            "
                                            @change="updateCondition"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!--  click  more content of popup layer  end -->
            </div>
        </div>
    </section>
</template>

<script>
import SearchTag from './search-tag-center.vue';
import OutsideRange from '../_component/outside-range';
import OutsideCheckbox from '../_component/outside-checkbox';
import Range from '../_component/range';
import SelectVirtual from '@/components/virtualize/select.vue';
import SInput from '../_component/s-input';
import Suggestion from '../_component/suggestion/index.vue';
import Keyword from '../_component/keyword';
import Checkbox from '../../../components/checkbox.vue';
import Core from '../search-more-center.js';
const ICON_MAP = {
    '%EE%A4%80': 'icon-bath',
    '%EE%A4%81': 'icon-bed',
    '%EE%A4%8A': 'icon-price',
    '%26%23xe90a%3B': 'icon-price',
    '%EE%A4%87': 'icon-house',
    '%26%23xe907%3B': 'icon-house',
    '%EE%A5%8C': 'icon-search-grid',
    '%26%23xe94c%3B': 'icon-search-grid'
};
export default {
    mixins: [Core],
    components: {
        Suggestion,
        SearchTag,
        SelectVirtual,
        Range,
        Checkbox,
        SInput,
        Keyword,
        OutsideRange,
        OutsideCheckbox
    },
    data: function() {
        return {
            theme: 'broker'
        };
    },
    methods: {
        getIcon(icon) {
            return ICON_MAP[encodeURIComponent(icon)] || '';
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../search-more.scss';
@mixin inputLableStyle() {
    height: 40px;
    background-color: white;
    box-shadow: var(--box-shadow);
    border: solid 1px #dadada;
    border-radius: 5px;
    @include media-800 {
        margin-right: 0;
        line-height: 16px;
        padding-top: 11px;
        padding-bottom: 11px;
    }
}

$listHoverColor: #f6f7fb;
.md-search-more-center.broker {
    input {
        @include placeholderMix(var(--font-bold), #c6c8d1, 14px);
    }
    .input_wrap .input {
        font-family: var(--font-bold);
    }
    .checkbox-li .label {
        @include media-800 {
            padding-left: 0;
            flex: 1;
        }
    }
    .select-mobile .container .drop_icon {
        padding-right: 0;
    }
    .v-select-dropdown,
    .dropdown_container {
        top: calc(100% + 3px);
        border-radius: 2px;
        box-shadow: 0px 2px 5px 0px rgba(25, 25, 25, 0.1);
    }
    .select-mobile .container .labels {
        font: 12px var(--font-bold);
    }
    .v-select-dropdown {
        min-width: 180px;
        z-index: 9;
    }
    .date-picker-input-wrapper {
        @include media-800 {
            @include placeholderMix(var(--font-bold), #c6c8d1, 12px);
        }
        @include media-min-800 {
            @include placeholderMix(var(--font-bold), #c6c8d1, 14px);
        }
        i.iconfont {
            left: 10px;
        }
    }
    .input_wrap {
        @include media-800 {
            @include placeholderMix(var(--font-bold), #c6c8d1, 12px);
        }
        @include media-min-800 {
            @include placeholderMix(var(--font-bold), #c6c8d1, 14px);
        }
    }
    .comp-im-checkbox .label {
        border: none;
        box-shadow: unset;
    }
    .im-option .item.selected {
        color: var(--g-btn-background);
    }

    .search-by {
        display: none;
    }
    .icon-arrow-down:after {
        font-size: 16px;
        color: #c6c8d1;
        display: inline-block;
    }
    .show-list,
    .show-more {
        .icon-arrow-down:after {
            transform: translateX(10px) rotate(180deg);
            -webkit-transform: translateX(10px) rotate(180deg);
        }
        .list-panel {
            display: block;
        }
    }
    .panel-style {
        box-sizing: border-box;
        overflow-y: auto;
        width: 100%;
        max-height: 300px;
        color: rgb(40, 40, 40);
        position: absolute;
        left: 0;
        top: 46px;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.05);
        border: 1px solid #dadada;
        background: #fff;
        min-width: 85px;
        border-radius: 5px;
        z-index: var(--level-subhigh);
        @include always-show-scroll(#dadada);
        li {
            line-height: 40px;
            padding: 0 0 0 15px;
            cursor: pointer;
            height: 40px;
            display: block;
            overflow: hidden;
            > span {
                width: calc(100% - 30px);
                @include ellipsis();
                display: inline-block;
            }
            .iconfont {
                float: right;
                padding-right: 14px;
                font-size: 12px;
            }
            &:hover {
                background-color: #f6f7fb;
            }
            &.selected {
                @include color-button-color();
                .iconfont {
                    display: block;
                }
                span {
                    color: var(--g-btn-background);
                }
            }
        }
    }
    .keyword {
        .list-panel {
            overflow-y: auto;
            .type-title {
                font: 14px var(--font-bold);
                padding-left: 8px;
                line-height: 30px;
                text-transform: capitalize;
                &:hover {
                    background-color: white;
                    cursor: default;
                }
            }
        }
    }
}

.md-search-more-center.broker {
    .more-keywords {
        width: 100%;
        .inputtext-area {
            position: relative;
            .keywords-input {
                @include inputLableStyle();
                width: 100%;
                padding: 0 98px 0 16px;
                border-radius: 5px 0 0 5px;
            }
            .keywords-button {
                position: absolute;
                bottom: 0;
                right: 0px;
                @include color-button();
                opacity: 0.9;
                width: 82px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 0 5px 5px 0;
                color: white;
                font-family: var(--font-bold);
                outline: none;
                font-size: 14px;
                &:hover {
                    opacity: 1;
                }
            }
            .tag-container {
                margin-top: -5px;
                .keywords-tag {
                    padding: 0 15px;
                    background: rgb(246, 246, 246);
                    font-size: 14px;
                    color: rgb(42, 42, 42);
                    margin-right: 10px;
                    display: inline-block;
                    box-sizing: border-box;
                    height: 40px;
                    line-height: 40px;
                    margin-top: 5px;
                    .icon-close {
                        /* color: #fff; */
                        color: #d1d1d1;
                        margin-left: 8px;
                        vertical-align: middle;
                        &:hover {
                            cursor: pointer;
                            color: rgb(42, 42, 42);
                        }
                    }
                }
            }
        }
    }

    @include media-min-800 {
        font-size: 14px;
        .if-is-phone {
            display: none;
        }
        background-color: #fff;
        input {
            &:focus {
                outline: none;
                border: 1px solid;
                @include color-theme('border-color');
            }
        }
        .icon-arrow-down {
            font-size: 12px;
            color: #c6c8d1;
            transform: translateX(10px);
        }
        .click-show-list,
        .more-btn {
            position: relative;
        }
        .list-panel {
            width: auto;
            min-width: 100%;
            li {
                padding: 5px 8px;
                cursor: pointer;
                height: 40px;
                display: block;
                position: relative;
                font: 14px var(--font-normal);
                line-height: 30px;
                color: #191919;
                &.filter-content {
                    &:after {
                        display: block;
                        content: '';
                        clear: both;
                    }
                    @include placeholderMix(var(--font-normal), #c6c8d1, 12px);
                    .iconfont {
                        position: absolute;
                        display: block;
                        padding: 0;
                        width: 20px;
                        text-align: center;
                        left: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                    .head {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        height: 60px;
                        border-bottom: 1px solid #e2e4ea;
                        padding: 0 15px;
                        .iconfont {
                            font-size: 14px;
                            color: #505050;
                            position: absolute;
                            left: 15px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                        p {
                            flex: 1;
                            text-align: center;
                            font: 16px var(--font-bold);
                            color: #000;
                        }
                    }
                    .filter-input {
                        width: calc(100% - 36px);
                        height: 36px;
                        border: none;
                        box-shadow: none;
                        background: #f3f3f3;
                        border-radius: 5px 0 0 5px;
                        padding-right: 30px;
                    }
                    .select-broker_search-btn {
                        width: 36px;
                        height: 36px;
                        background: var(--g-btn-background);
                        color: #fff;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 0 5px 5px 0;
                        .iconfont {
                            font-size: 18px;
                            color: #fff;
                        }
                    }
                    .icon-Empty {
                        position: absolute;
                        right: 60px;
                        bottom: 20px;
                        line-height: 26px;
                        font-size: 14px;
                        color: #dadada;
                        text-transform: capitalize;
                        text-align: center;
                    }
                    .panel-result {
                        font: 14px var(--font-bold);
                        color: #383838;
                        line-height: 40px;
                    }
                    .iconfont {
                        padding-right: 0;
                        float: unset;
                    }
                    &:hover {
                        background-color: #ffffff;
                    }
                }
                > span {
                    width: auto;
                    padding-right: 30px;
                    display: inline-block;
                }
                .iconfont {
                    display: none;
                    float: none;
                    position: absolute;
                    right: 0;
                    top: 0;
                    padding-right: 14px;
                    font-size: 12px;
                }
                &:hover {
                    background-color: #f6f7fb;
                }
                &.selected {
                    @include color-button-color();
                    .iconfont {
                        display: block;
                    }
                }
            }
        }
        .more-list {
            position: absolute;
            width: 513px;
            max-width: none;
            z-index: calc(var(--level-sublow) + 1);
            top: 100%;
            right: 20px;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
            display: none;
            background-color: white;
            input {
                font-size: 14px;
                font-family: var(--font-bold);
                color: #191919;
                &::-webkit-input-placeholder {
                    font: 14px var(--font-bold);
                    color: #c6c8d1;
                }
            }
            &.show-more-list {
                display: block;
            }
            .checkbox-values {
                display: none;
            }
            .more-list-scroll {
                position: absolute;
                padding-top: 30px;
                padding-bottom: 30px;
                top: 0;
                bottom: 0;
                overflow-y: auto;
                left: 0;
                right: 0;
                display: flex;
                flex-direction: column;
                border-radius: 5px;
                box-shadow: 0 2px 20px 0 rgba(0, 10, 30, 0.1);
                background-color: #fff;
                .more-reset {
                    position: absolute;
                    right: 30px;
                    top: 30px;
                    color: #505050;
                    cursor: pointer;
                    .iconfont {
                        padding-right: 10px;
                        font-size: 12px;
                    }
                }
            }
            .section-box {
                padding: 0 30px 35px 30px;
                flex: none;
                display: flex;
                flex-direction: column;
                &.search_tag {
                    padding-bottom: 25px;
                    .md-search-tag .search-filter > label {
                        color: #505050;
                        margin-bottom: 10px;
                    }
                }
                h2 {
                    font-size: 16px;
                    font-weight: normal;
                    font-family: var(--font-bold);
                    height: 20px;
                    line-height: 20px;
                    color: #191919;
                    .icon-arrow-down {
                        display: none;
                    }
                }
                .section {
                    width: 100%;
                    display: flex;
                    padding: 5px 0;
                    flex-flow: column wrap;
                    .inputtext-area {
                        width: 100%;
                        font-size: 14px;
                        color: #191919;
                        font-family: var(--font-bold);
                        margin-top: 15px;
                        box-sizing: border-box;
                        .name {
                            font: 12px var(--font-medium);
                            color: #505050;
                            display: block;
                            padding-bottom: 10px;
                        }
                    }
                    .checkbox-li {
                        line-height: 17px;
                        display: flex;
                        margin-top: 15px;
                        align-items: baseline;
                        &:first-child {
                            margin-top: 0;
                        }
                        /* cursor: pointer; */
                        &.selected {
                            color: var(--g-btn-background);
                        }
                    }
                    .inputtext-area {
                        & + .checkbox-li {
                            width: 100%;
                            margin-top: 20px;
                            & + .checkbox-li {
                                margin-left: 0; //-80%;
                            }
                        }
                    }
                }
                .range-input-parent {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    .input-container {
                        flex: 1;
                        margin: 0;
                        padding-right: 20px;
                        input {
                            @include inputLableStyle();
                            width: 100%;
                            padding: 0 10px;
                            &:focus {
                                outline: none;
                                border: 1px solid;
                                @include color-theme('border-color');
                            }
                        }
                        &.input_1 {
                            padding-right: 0;
                        }
                    }
                }
                .selectdown {
                    @include inputLableStyle();
                    line-height: 40px;
                    .title {
                        width: 100%;
                        display: flex;
                    }
                    .text {
                        flex: 1;
                        display: block;
                        @include ellipsis();
                        padding: 0 10px;
                        cursor: pointer;
                    }
                    .filter-input {
                        flex: 1;
                        border: none;
                        height: 38px;
                        box-shadow: none;
                        padding: 0 10px;
                        background-color: transparent;
                        cursor: pointer;
                    }
                    .list-panel {
                        top: 40px;
                    }
                }
            }
            .section-second {
                padding: 0 0 15px 0;
                h2 {
                    position: relative;
                    padding: 0 30px;
                    font-weight: normal;
                    font-size: 16px;
                    font-family: var(--font-bold);
                    color: #191919;
                    margin-bottom: 12px;
                    .icon-arrow-down {
                        position: absolute;
                        top: 0;
                        right: 0;
                    }
                }
                .section {
                    padding: 5px 30px 5px 30px;
                }
            }
        }
        @media (max-width: 1200px) {
            .more-list {
                right: 0;
            }
        }
        @include media-1080 {
            .more-list {
                right: -20px;
                margin: 0;
            }
        }
        .search-by-section {
            position: relative;
            z-index: auto;
            top: 0;
            display: flex;
            margin-top: -20px;
            flex-wrap: wrap;
            @include placeholderMix(var(--font-normal), #c6c8d1, 12px);
            .keyword-container {
                margin-top: 20px;
                margin-right: 15px;
                flex-grow: 1;
                height: 44px;
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                .search-category {
                    flex: 1;
                    top: 0;
                    left: 0;
                    margin-right: 15px;
                    z-index: calc(var(--level-sublow));
                    position: relative;
                    .keyword {
                        flex: 1;
                        position: relative;
                        width: 100%;
                        &.hide {
                            display: none;
                        }
                        .search-input {
                            width: 100%;
                            height: 44px;
                            line-height: 14px;
                            font-size: 14px;
                            color: #515666;
                            padding-left: 12px;
                            border: 1px solid transparent;
                            box-shadow: none;
                            -webkit-appearance: none;
                            background: #f3f3f3;
                            border-radius: 5px 0 0 5px;
                            &:focus {
                                outline: none;
                            }
                            &::-webkit-input-placeholder {
                                color: #c6c8d1;
                            }
                        }
                        .keyword-submit {
                            display: none;
                        }
                    }
                    .keyword-submit {
                        position: absolute;
                        top: 0;
                        right: 0;
                        height: 44px;
                        width: 50px;
                        line-height: 44px;
                        text-align: center;
                        cursor: pointer;
                        color: #fff;
                        border-radius: 0 5px 5px 0;
                        background: var(--g-btn-background);
                        .icon-search {
                            font-weight: bold;
                            font-size: 20px;
                        }
                        div {
                            display: none;
                        }
                    }
                }
            }
            .save-search {
                padding-left: 10px;
                padding-right: 10px;
                cursor: pointer;
                color: #191919;
                position: relative;
                height: 44px;
                line-height: 44px;
                background-color: #f3f3f3;
                font-size: 14px;
                font-family: var(--mg-button-font);
                white-space: nowrap;
                border-radius: 5px;
                margin-top: 0;
                margin-left: 0;
                margin-right: 0;
                .icon-heart-fill {
                    color: #f0454c;
                    margin-right: 10px;
                }
                &.disabled {
                    opacity: 0.8;
                    cursor: not-allowed;
                }
                &.hide-icon {
                    width: auto;
                    padding-left: 10px;
                }
                &.save-snapshot {
                    padding: 0 10px;
                    text-align: center;
                    display: block;
                    height: 100%;
                }
            }
            @include media-1260 {
                flex-wrap: wrap;
                justify-content: space-between;
                .keyword-container {
                    width: 100%;
                    // margin-bottom: 20px;
                    margin-right: 0;
                }
            }
        }
        .search-more {
            margin-top: 20px;
            .list-panel {
                top: 42px;
            }
            .icon-arrow-down {
                margin-left: 8px;
                margin-right: 0;
            }
            .search-detail-wrap {
                display: flex;
                margin: 0 auto;
                border-bottom: none;
                align-items: center;
                position: relative;
                flex-wrap: wrap;
                .search-detail-item {
                    background-color: white;
                    color: #191919;
                    position: relative;
                    font: 14px var(--font-medium);
                    height: 44px;
                    line-height: 42px;
                    align-items: center;
                    padding: 0 10px;
                    margin-right: 15px;
                    border-radius: 5px;
                    border: solid 1px #dadada;
                    background-color: #ffffff;
                    .iconfont {
                        color: #000;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .name {
                        display: none;
                    }
                    .box-div {
                        width: 100%;
                        height: 100%;
                        align-items: center;
                        display: flex;
                        padding-left: 0;
                        .title {
                            height: 100%;
                            flex: 1;
                            display: flex;
                            overflow: hidden;
                            cursor: pointer;
                            .text {
                                @include ellipsis();
                            }
                        }
                        .logo {
                            font-size: 16px;
                            margin-right: 10px;
                            color: #515666;
                            cursor: pointer;
                        }
                        .hide-logo-long {
                            display: none;
                        }
                        &:after {
                            content: '';
                            height: 30px;
                            width: 1px;
                            background-color: #ebecf1;
                        }
                    }
                    &:last-child {
                        .box-div:after {
                            content: none;
                        }
                    }
                    &.more-btn {
                        > div {
                            border: none;
                        }
                    }
                    &.select {
                        flex: auto;
                        width: auto;
                        display: flex;
                        min-width: 150px;
                        .box-div {
                            .text {
                                flex: 1;
                                @include ellipsis();
                                cursor: pointer;
                                &.web {
                                    display: block;
                                }
                                &.mobile {
                                    display: none;
                                }
                            }
                            .choosed-value {
                                // padding-right: 4px;
                                display: block;
                                @include ellipsis();
                            }
                        }
                    }
                    &.small-item {
                        width: auto;
                    }
                    &.range-item {
                        .title {
                            cursor: pointer;
                            label {
                                cursor: pointer;
                            }
                        }
                    }
                }
                .show-list {
                    .range-input-parent.list-panel {
                        display: flex;
                        z-index: var(--level-subhigh);
                    }
                }
                .range-input-parent {
                    width: 100%;
                    &.box-div {
                        display: flex;
                        align-items: center;
                        cursor: auto;
                        .text {
                            margin-right: 6px;
                            cursor: default;
                            flex: inherit;
                        }
                    }
                    &.list-panel {
                        position: absolute;
                        width: 316px;
                        left: 0;
                        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                        border: solid 1px #ebecf1;
                        background-color: white;
                        padding: 20px;
                        justify-content: space-between;
                        .input-container {
                            width: 120px;
                            margin: 0;
                            line-height: normal;
                            .list-panel {
                                // display: block;
                                border: none;
                                box-shadow: none;
                                margin-top: 10px;
                                padding: 0;
                                position: relative;
                                top: 0;
                                left: 0;
                                &.disabled {
                                    cursor: not-allowed;
                                    color: #c6c8d1;
                                    display: none;
                                    &:after {
                                        content: '';
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        width: 100%;
                                        height: 100%;
                                        z-index: 1;
                                    }
                                }
                                li {
                                    padding: 0 10px;
                                    span {
                                        width: 100%;
                                        padding: 0;
                                    }
                                }
                            }
                        }
                        .price-line {
                            margin-top: 14px;
                        }
                    }
                    .price-line {
                        width: 6px;
                        height: 1px;
                        background-color: #c6c8d1;
                        display: inline-block;
                        vertical-align: middle;
                        margin: 0 5px;
                    }
                    .input-container {
                        margin: 0 10px;
                        position: relative;
                        height: 100%;
                        .list-panel {
                            left: -0;
                            right: -50px;
                            width: inherit;
                        }
                        input {
                            width: 120px;
                            height: 30px;
                            padding: 0 10px;
                            color: #515666;
                            line-height: 14px;
                        }
                        &.show-list {
                            input {
                                outline: none;
                                border: 1px solid;
                                @include color-theme('border-color');
                            }
                        }
                        &.input_1 {
                            margin-right: 0;
                        }
                    }
                }
                .more-btn {
                    max-width: 200px;
                    position: static;
                    cursor: pointer;
                    color: #191919;
                    font-size: 14px;
                    .more-len {
                        text-align: right;
                        display: block;
                        margin-left: 8px;
                        width: 20px;
                        height: 20px;
                        background: var(--g-btn-background);
                        color: #fff;
                        font: 14px var(--font-medium);
                        border-radius: 5px;
                        text-align: center;
                        line-height: 20px;
                        padding: 0;
                    }
                    .logo.icons {
                        font-size: 16px;
                    }
                    .text {
                        cursor: pointer;
                    }
                    &.open {
                        .icon-arrow-down::before {
                            display: block;
                            transform: translateX(10px) rotate(180deg);
                        }
                    }
                }
            }
            &.compose {
                margin-top: 0px;
                .search-detail-wrap .search-detail-item {
                    margin-top: 20px;
                }
                // .more-list {
                //     left: 0;
                // }
            }
            @include media-1080 {
                .icons.logo {
                    display: none;
                }
            }
        }
    }
    @include media-800 {
        color: #191919;
        font-size: 14px;
        padding: 0;
        overflow-y: auto;
        overflow-x: hidden;
        .mg-container {
            width: 100%;
            margin: 0;
            overflow: visible;
        }
        .icon-arrow-down {
            color: #c6c8d1;
        }
        .search-by-section {
            .save-search {
                display: none;
            }
        }
        .search-category {
            margin-left: 15px;
            margin-right: 15px;
            &.keyword-only {
                padding: 15px;
                background-color: #fff;
                margin: 0;
                .keyword {
                    margin: 0;
                    padding: 0;
                    display: flex;
                    height: 36px;
                    align-items: center;
                    box-shadow: none;
                    border: none;
                    background-color: white;
                    input {
                        padding-left: 44px;
                        padding-right: 30px;
                        box-shadow: none;
                        height: 100%;
                    }
                    .keyword-submit {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 36px;
                        height: 36px;
                    }
                    .btn-remove {
                        position: absolute;
                        z-index: 2;
                        right: 72px;
                        top: 50%;
                        transform: translateY(-50%) scale(0.5);
                        width: 28px;
                        height: 28px;
                        line-height: 24px;
                        text-align: center;
                        border-radius: 50%;
                        background-color: #dadce2;
                        color: white;
                        font-size: 14px;
                    }
                    .btn-close {
                        width: 70px;
                        line-height: 36px;
                        font-size: 14px;
                        color: #fff;
                        text-transform: capitalize;
                        text-align: center;
                        background: var(--g-btn-background);
                        border-radius: 0 5px 5px 0;
                    }
                    .list-panel {
                        position: fixed;
                        top: 66px;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        box-shadow: none;
                        border: none;
                        max-height: none;
                    }
                }
            }
            .search-by {
                display: none;
            }
        }
        .keyword-submit {
            display: none;
        }
        .keyword {
            margin-top: 20px;
            height: 36px;
            line-height: 36px;
            padding: 0;
            display: flex;
            align-items: center;
            position: relative;
            border: solid 1px #ebecf1;
            border-radius: 5px;
            @include placeholderMix(var(--font-medium), #c6c8d1);
            .search-input {
                border: none;
                box-shadow: none;
                height: 38px;
                line-height: 14px;
                flex: 1;
                padding: 12px 10px 12px 44px;
                box-shadow: var(--box-shadow);
                background: #f3f3f3;
                border-radius: 5px;
                @include ellipsis();
                &:focus {
                    border: none;
                }
            }
            .list-panel {
                top: 48px;
            }
            .keyword-submit {
                display: block;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 36px;
                width: 36px;
                text-align: center;
                color: #fff;
                background: var(--g-btn-background);
                font-weight: bold;
                border-radius: 5px 0 0 5px;
                .icon-search {
                    font-size: 18px;
                }
            }
        }
        .search-more.search-detail {
            margin: 10px 15px 0;
        }
        .search-detail-wrap {
            padding-bottom: 20px;
            border-bottom: 1px solid #e2e4ea;
        }
        .search-detail-item {
            padding: 20px 0 0;
            > .box-div,
            .selectdown {
                position: relative;
            }
            .logo {
                display: none;
            }
            .price-line {
                padding: 0 6px;
                width: 9px;
                height: 1px;
                vertical-align: middle;
                background-color: #c6c8d1;
                display: inline-block;
                vertical-align: middle;
                margin: 0 5px;
            }
            &.small-item {
                padding-left: 0;
                padding-right: 0;
                display: inline-block;
                width: calc(50% - 28px);
                margin-right: 20px;
                margin-left: 15px;
                & + .small-item {
                    margin-left: 0;
                    margin-right: 0;
                }
            }
        }
        .range-input-parent {
            position: static;
            display: flex;
            align-items: center;
            .input-container {
                position: relative;
                flex: 1;
            }
            .price-line {
                padding: 0 6px;
                width: 9px;
                height: 1px;
                background-color: #c6c8d1;
                margin: 0 5px;
            }
            .list-panel {
                display: none;
            }
        }
        .range-item {
            .input_0 {
                margin-right: 0;
            }
            .text,
            .title {
                display: none;
            }
        }
        .inputtext-area {
            flex: 1;
            margin-bottom: 20px;
            &.no-wrap {
                // display: flex;
                align-items: center;
                .name {
                    margin-bottom: 0;
                    flex: none;
                    line-height: 16px;
                }
                .click-show-list {
                    flex: 1;
                    // margin-left: 10px;
                    overflow: hidden;
                }
                .title {
                    border: none;
                    box-shadow: none;
                    height: auto;
                    padding: 7px 0;
                }
                .text {
                    text-align: right;
                    font: 12px var(--font-bold);
                    color: #191919;
                    padding-right: 10px;
                }
                .list-panel {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    padding-top: 66px;
                    max-height: none !important;
                    border: none;
                    box-shadow: none;
                    .filter-content {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 66px;
                        padding: 15px;
                        margin: 0;
                        background-color: #f8f9fd;
                        .icon-search {
                            display: block;
                            position: absolute;
                            left: 25px;
                            top: 50%;
                            transform: translateY(-50%);
                            padding-right: 0;
                        }
                        .filter-input {
                            width: 100%;
                            height: 100%;
                            border: none;
                            box-shadow: none;
                            padding: 0 75px 0 30px;
                        }
                        .close {
                            position: absolute;
                            right: 15px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 70px;
                            line-height: 26px;
                            font-size: 14px;
                            color: var(--mg-button-background, #03c9ff);
                            text-transform: capitalize;
                            text-align: center;
                            border-left: 2px solid #bfc9e4;
                        }
                    }
                    li:not(.filter-content) {
                        color: #515666;
                        position: relative;
                        &:hover {
                            background-color: transparent;
                        }
                        .iconfont {
                            display: block !important;
                            right: 15px;
                            bottom: 8px;
                            position: absolute;
                            -moz-osx-font-smoothing: grayscale;
                            width: 15px;
                            height: 15px;
                            padding: 0;
                            line-height: 15px;
                            text-align: center;
                            border-radius: 0;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                            border: solid 1px #ebecf1;
                            background-color: #ffffff;
                            &::before {
                                display: none;
                                @include color-button-color();
                                font-size: 12px;
                                font-weight: bold;
                            }
                        }
                        &.selected .iconfont {
                            &::before {
                                display: block;
                            }
                        }
                    }
                }
            }
            &:last-child {
                margin-bottom: 10px;
            }
            .click-show-list {
                position: relative;
            }
        }
        .more-keywords {
            display: block;
            .inputtext-area {
                padding-right: 0;
                margin-bottom: 0;
                margin-top: 20px;
                &:first-child {
                    margin-top: 0;
                }
                .keywords-button {
                    right: 0;
                }
                .tag-container {
                    margin-top: 0;
                }
            }
        }
        .checkbox-li {
            padding: 0;
            flex-direction: row-reverse;
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 32px;
            color: #505050;
            .iconfont {
                margin-right: 0;
                width: 15px;
                height: 15px;
                box-shadow: var(--box-shadow);
                border: solid 1px #ebecf1;
                background-color: #ffffff;
                border-radius: 0;
                line-height: 15px;
                text-align: center;
                font-size: 12px;
                font-weight: bold;
            }
            & + .inputtext-area {
                padding-top: 16px;
            }
        }
        .more-btn,
        .more-reset {
            display: none;
        }
        .section-box {
            margin-top: 10px;
            padding: 0;
            padding-bottom: 20px;
            border-bottom: solid 1px #e2e4ea;
            &:last-child {
                border-bottom: none;
            }
            h2 {
                padding: 20px 0;
                display: flex;
                font-size: 14px;
                font-weight: normal;
                font-family: var(--font-bold);
                line-height: 15px;
                color: #202437;
                text-transform: uppercase;
                .icon-arrow-down {
                    display: none;
                }
            }
            .search-detail-item {
                padding-left: 0;
                padding-right: 0;
            }
        }
        .section-second {
            border-bottom: solid 1px #e2e4ea;
            padding-bottom: 10px;
            .section {
                display: none;
                margin-top: 0;
                padding: 0 0 10px;
                .checkbox-li {
                    &:last-child {
                        padding-bottom: 0;
                    }
                }
                .inputtext-area {
                    & + .checkbox-li {
                        padding-top: 0;
                    }
                }
            }
            h2 {
                .icon-arrow-down {
                    display: block;
                }
                &.show-list {
                    .icon-arrow-down {
                        transform: translateX(10px) rotate(180deg);
                    }
                }
                &.show-list + .section {
                    display: block;
                }
            }
        }
        .text {
            flex: 1;
            @include ellipsis();
            padding-right: 15px;
            font: 16px var(--font-bold);
            color: #282828;
            &.web {
                display: none;
            }
            &.mobile {
                display: block;
            }
        }
        .choosed-value {
            display: none;
        }
        .title {
            display: flex;
            @include inputLableStyle();
            @include placeholderMix(var(--font-bold), #c6c8d1);
            line-height: 40px;
            padding-left: 15px;
            padding-right: 15px;
        }
        input {
            @include inputLableStyle();
            padding-left: 15px;
            padding-top: 11px;
            padding-bottom: 11px;
            width: 100%;
            font-size: 12px;
            font-family: var(--font-bold);
            color: #191919;
            line-height: 16px;
        }
        .name {
            margin-bottom: 15px;
            font-size: 14px;
            color: #202437;
        }
        .checkbox-values {
            display: none;
        }
        // select style override
        .search-detail-item,
        .click-show-list {
            &.two-column {
                .box-div {
                    .name {
                        font-size: 16px;
                        color: #191919;
                        font-family: var(--font-bold);
                    }
                    @include media-600 {
                        .panel-style {
                            top: 0;
                        }
                    }
                    .title {
                        display: none;
                    }
                    .list-panel {
                        display: block !important;
                        position: inherit;
                        box-shadow: none;
                        border: none;
                        padding: 0;
                        li {
                            width: calc(50% - 10px);
                            float: left;
                            height: 40px;
                            font: 12px var(--font-bold);
                            color: #191919;
                            line-height: 37px;
                            text-align: center;
                            border: solid 1px #dadada;
                            padding: 0;
                            span {
                                width: 100%;
                            }
                            &:nth-child(odd) {
                                margin-right: 10px;
                            }
                            &:nth-child(even) {
                                margin-left: 10px;
                            }
                            &:hover {
                                background-color: transparent;
                            }
                            &.selected {
                                position: relative;
                                border: 1px solid var(--mg-button-background);
                                @include color-button-color;
                                color: #191919;
                                &:before {
                                    position: absolute;
                                    content: '';
                                    left: 0;
                                    right: 0;
                                    top: 0;
                                    bottom: 0;
                                    background-color: var(
                                        --mg-button-background
                                    );
                                    opacity: 0.1;
                                }
                            }
                        }
                    }
                }
                &.two-column-4 {
                    .box-div .list-panel {
                        max-height: none;
                        li {
                            margin-bottom: 10px;
                            &:nth-child(n + 5) {
                                width: 100%;
                                padding: 0;
                                color: #515666;
                                position: relative;
                                border: none;
                                margin-right: 0;
                                margin-left: 0;
                                margin-bottom: 0;
                                height: 32px;
                                font: 12px var(--font-normal);
                                color: #505050;
                                line-height: 32px;
                                text-align: left;
                                &:hover {
                                    background-color: transparent;
                                }
                                &.selected {
                                    // color: #515666;
                                    &::before {
                                        display: none;
                                    }
                                }
                                .iconfont {
                                    display: block !important;
                                    right: 0;
                                    bottom: 8px;
                                    position: absolute;
                                    -moz-osx-font-smoothing: grayscale;
                                    width: 15px;
                                    height: 15px;
                                    padding: 0;
                                    line-height: 15px;
                                    text-align: center;
                                    border-radius: 0;
                                    box-shadow: inset 0 2px 4px 0
                                        rgba(0, 0, 0, 0.1);
                                    border: solid 1px #ebecf1;
                                    background-color: #ffffff;
                                    &::before {
                                        display: none;
                                        @include color-button-color();
                                        font-size: 12px;
                                        font-weight: bold;
                                    }
                                }
                                &.selected .iconfont {
                                    &::before {
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            &.check-list {
                .box-div {
                    .name {
                        font-size: 14px;
                        color: #202437;
                    }
                    .title {
                        display: none;
                    }
                    .list-panel {
                        display: block !important;
                        position: inherit;
                        box-shadow: none;
                        border: none;
                        padding: 0;
                        li {
                            padding: 0;
                            color: #515666;
                            position: relative;
                            &:hover {
                                background-color: transparent;
                            }
                            .iconfont {
                                display: block !important;
                                right: 0;
                                bottom: 8px;
                                position: absolute;
                                -moz-osx-font-smoothing: grayscale;
                                width: 15px;
                                height: 15px;
                                padding: 0;
                                line-height: 15px;
                                text-align: center;
                                border-radius: 0;
                                box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                                border: solid 1px #ebecf1;
                                background-color: #ffffff;
                                &::before {
                                    display: none;
                                    @include color-button-color();
                                    font-size: 12px;
                                    font-weight: bold;
                                }
                            }
                            &.selected .iconfont {
                                &::before {
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
            &.select-list {
                .box-div {
                    .name {
                        font-size: 14px;
                        color: #202437;
                    }
                    .list-panel {
                        z-index: 999;
                    }
                }
            }
        }
    }

    .more-btn {
        .text {
            display: flex;
            align-items: center;
        }
    }
}
</style>
